import config from '../config/config';

/**
 * Detecta la app actual basándose ÚNICAMENTE en el hostname
 * Extrae el primer subdominio del hostname
 *
 * Ejemplos:
 *   - asma.local → "asma"
 *   - asma.mo.innovacionsalud.org → "asma"
 *   - preanestesas.innovacionsalud.org → "preanestesas"
 *   - localhost → "localhost"
 *   - 127.0.0.1 → "127"
 *
 * @returns {string} Nombre de la app
 */
export const detectApp = () => {
  const hostname = window.location.hostname;
  // Extraer primer subdominio (parte antes del primer punto)
  return hostname.split('.')[0];
};

/**
 * Capitaliza el nombre de una app
 * Ejemplos: "asma" → "Asma", "geoasma" → "Geoasma"
 *
 * @param {string} app - Nombre de la app
 * @returns {string} Nombre capitalizado
 */
const capitalizeAppName = (app) => {
  return app.charAt(0).toUpperCase() + app.slice(1);
};

/**
 * Obtiene la configuración de una app con valores por defecto inteligentes
 *
 * Lógica:
 * 1. Toma los valores por defecto (color, etc.)
 * 2. Sobrescribe con la config específica de la app (si existe)
 * 3. Si no tiene 'name' configurado, usa el nombre de la app capitalizado
 * 4. Si no tiene 'systemUser' configurado, usa el nombre de la app
 *
 * Ejemplos:
 *   - App "nuevaapp" sin config → {name: "Nuevaapp", systemUser: "nuevaapp", ...defaults}
 *   - App "cronicare" con systemUser custom → {systemUser: "us_cronicare", ...resto de su config, ...defaults}
 *
 * @param {string} app - Nombre de la app
 * @returns {object} Configuración completa de la app
 */
export const getAppConfig = (app) => {
  const appConfig = config[app] || {};
  const defaults = config['default'];

  return {
    // 1. Empezar con valores por defecto (colores, etc.)
    ...defaults,
    // 2. Sobrescribir con la configuración específica de la app (si existe)
    ...appConfig,
    // 3. Si no tiene 'name' definido, usar el nombre de la app capitalizado
    name: appConfig.name || capitalizeAppName(app),
    // 4. Si no tiene 'systemUser' definido, usar el nombre de la app
    systemUser: appConfig.systemUser || app,
  };
};
